/* import __COLOCATED_TEMPLATE__ from './action-banner.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './action-banner.module.scss';

@classic
@classNames(styles.component)
export default class SiteActionBanner extends Component {}
